
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import SaasSignupForm from '@/components/SaasSignupForm';
import { useToast } from '@/hooks/use-toast';
import { SaasSignupFormValues } from '@/schemas/saasSignupSchema';

const SaasSignup: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSubmit = async (data: SaasSignupFormValues & { captcha: string }) => {
    setIsLoading(true);
    try {
      // Simulate API call
      console.log('SaaS signup data:', data);
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      toast({
        title: 'Account created!',
        description: 'Your SaaS account has been created successfully.',
      });
      
      navigate('/saas-login');
    } catch (error) {
      console.error('SaaS signup error:', error);
      toast({
        title: 'Signup Failed',
        description: 'There was a problem creating your account. Please try again.',
        variant: 'destructive',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-6">
        <h1 className="text-3xl font-bold">Start Your Referral Program</h1>
        <p className="text-gray-600 mt-2">Sign up for our SaaS platform and start growing your business</p>
      </div>
      
      <div className="max-w-xl w-full">
        <Card>
          <CardHeader>
            <CardTitle>Create your account</CardTitle>
            <CardDescription>Fill in the details to get started with your free trial</CardDescription>
          </CardHeader>
          <CardContent>
            <SaasSignupForm onSubmit={handleSubmit} isLoading={isLoading} />
          </CardContent>
        </Card>
        
        <div className="text-center mt-4">
          <p className="text-sm text-gray-600">
            Already have an account?{' '}
            <a 
              href="/saas-login" 
              className="font-medium text-primary hover:text-primary/90"
            >
              Log in
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SaasSignup;
